import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bulkEditErrorTitle: {
    description: 'bulkUpdateEpics.bulkEditErrorTitle',
    defaultMessage: 'Bulk Edit Error',
    id: 'QG84+3',
  },
  customsErrorMessage: {
    description: 'bulkUpdateEpics.customsErrorMessage',
    defaultMessage: 'Cannot set customs on domestic shipments.',
    id: 'kY1l5p',
  },
  otherShippingOptionsErrorMessage: {
    description: 'bulkUpdateEpics.otherShippingOptionsErrorMessage',
    defaultMessage: 'Cannot set other shipping options on shipments without services selected.',
    id: 'vO47Vx',
  },
  servicesErrorMessage: {
    description: 'bulkUpdateEpics.servicesErrorMessage',
    defaultMessage: 'Cannot set shipping service for mixed domestic and international shipments',
    id: 'CyYiVR',
  },
  bulkUpdateDrawerShippingStrategiesWarning: {
    defaultMessage: 'Bulk actions will not apply to orders that use Rate Shopper.',
    description: 'Warning message to show when bulk updating orders with rate shopper',
    id: 'C7eJda',
  },
  bulkUpdateModalConfirmationShippingStrategiesError: {
    defaultMessage: 'Cannot set confirmation for orders with Rate Shopper',
    description: 'Error message to show when bulk updating confirmation to orders with rate shopper',
    id: 'OBmlHh',
  },
  bulkUpdateModalPackageShippingStrategiesError: {
    defaultMessage: 'Cannot set package for orders with Rate Shopper',
    description: 'Error message to show when bulk updating package to orders with rate shopper',
    id: '/ERCDv',
  },
  insuranceMultiplePackagesErrorMessage: {
    defaultMessage: 'Cannot bulk update insurance on multi-package shipments. Remove multi-package shipments from selection and try again.',
    description: 'Error message to show when bulk updating insurance for multiple packages',
    id: 'JEQYaI',
  },
  weightMultiplePackagesErrorMessage: {
    defaultMessage: 'Cannot bulk update weight on multi-package shipments. Remove multi-package shipments from selection and try again.',
    description: 'Error message to show when bulk updating weight for multiple packages',
    id: 'sgg5zT',
  },
  sizeMultiplePackagesErrorMessage: {
    defaultMessage: 'Cannot bulk update size on multi-package shipments. Remove multi-package shipments from selection and try again.',
    description: 'Error message to show when bulk updating size for multiple packages',
    id: 'gl1MoK',
  },
});
